import common from "./common";
import desktop from "./desktop";

const templates = {
    desktop,
    common,
};

export default templates;
